// Get Supplier List ActionType
export const GET_SUPPLIER_LIST = "GET_SUPPLIER_LIST";
export const GET_SUPPLIER_LIST_SUCCESS = "GET_SUPPLIER_LIST_SUCCESS";
export const GET_SUPPLIER_LIST_FAILURE = "GET_SUPPLIER_LIST_FAILURE";

// Single Supplier Details ActionType
export const GET_SUPPLIER_DETAILS = "GET_SUPPLIER_DETAILS";
export const GET_SUPPLIER_DETAILS_SUCCESS = "GET_SUPPLIER_DETAILS_SUCCESS";
export const GET_SUPPLIER_DETAILS_FAILURE = "GET_SUPPLIER_DETAILS_FAILURE";

// Create New Supplier ActionType
export const CREATE_SUPPLIER = "CREATE_SUPPLIER";
export const CREATE_SUPPLIER_SUCCESS = "CREATE_SUPPLIER_SUCCESS";
export const CREATE_SUPPLIER_FAILURE = "CREATE_SUPPLIER_FAILURE";

// Update Supplier ActionType
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER";
export const UPDATE_SUPPLIER_SUCCESS = "UPDATE_SUPPLIER_SUCCESS";
export const UPDATE_SUPPLIER_FAILURE = "UPDATE_SUPPLIER_FAILURE";

// Delete Supplier ActionType
export const DELETE_SUPPLIER = "DELETE_SUPPLIER";
export const DELETE_SUPPLIER_SUCCESS = "DELETE_SUPPLIER_SUCCESS";
export const DELETE_SUPPLIER_FAILURE = "DELETE_SUPPLIER_FAILURE";

//Get Supplier Recent Activity
export const GET_SUPPLIER_RECENT_ACTIVITY = "GET_SUPPLIER_RECENT_ACTIVITY";
export const GET_SUPPLIER_RECENT_ACTIVITY_SUCCESS =
  "GET_SUPPLIER_RECENT_ACTIVITY_SUCCESS";
export const GET_SUPPLIER_RECENT_ACTIVITY_FAILURE =
  "GET_SUPPLIER_RECENT_ACTIVITY_FAILURE";

// Supplier Notes
export const SEARCH_SUPPLIER_NOTE = "SEARCH_SUPPLIER_NOTE";
export const SEARCH_SUPPLIER_NOTE_SUCCESS = "SEARCH_SUPPLIER_NOTE_SUCCESS";
export const SEARCH_SUPPLIER_NOTE_FAILURE = "SEARCH_SUPPLIER_NOTE_FAILURE";

export const CREATE_SUPPLIER_NOTE = "CREATE_SUPPLIER_NOTE";
export const CREATE_SUPPLIER_NOTE_SUCCESS = "CREATE_SUPPLIER_NOTE_SUCCESS";
export const CREATE_SUPPLIER_NOTE_FAILURE = "CREATE_SUPPLIER_NOTE_FAILURE";

export const DELETE_SUPPLIER_NOTE = "DELETE_SUPPLIER_NOTE";
export const DELETE_SUPPLIER_NOTE_SUCCESS = "DELETE_SUPPLIER_NOTE_SUCCESS";
export const DELETE_SUPPLIER_NOTE_FAILURE = "DELETE_SUPPLIER_NOTE_FAILURE";

// Supplier Attachments
export const SEARCH_SUPPLIER_ATTACHMENT = "SEARCH_SUPPLIER_ATTACHMENT";
export const SEARCH_SUPPLIER_ATTACHMENT_SUCCESS =
  "SEARCH_SUPPLIER_ATTACHMENT_SUCCESS";
export const SEARCH_SUPPLIER_ATTACHMENT_FAILURE =
  "SEARCH_SUPPLIER_ATTACHMENT_FAILURE";

export const DELETE_SUPPLIER_ATTACHMENT = "DELETE_SUPPLIER_ATTACHMENT";
export const DELETE_SUPPLIER_ATTACHMENT_SUCCESS =
  "DELETE_SUPPLIER_ATTACHMENT_SUCCESS";
export const DELETE_SUPPLIER_ATTACHMENT_FAILURE =
  "DELETE_SUPPLIER_ATTACHMENT_FAILURE";

// Supplier Balance Historical — monthly snapshots for one supplier
export const GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER =
  "GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER";
export const GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_SUCCESS =
  "GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_SUCCESS";
export const GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_FAILURE =
  "GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_FAILURE";

// Supplier Balance Historical — distinct recorded dates (date picker)
export const GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES =
  "GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES";
export const GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS =
  "GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS";
export const GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAILURE =
  "GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAILURE";

// Supplier Balance Historical — whole-book snapshot for one date
export const GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE =
  "GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE";
export const GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS =
  "GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS";
export const GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAILURE =
  "GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAILURE";

// Supplier Url Links (Task 24318)
export const SEARCH_SUPPLIER_URL_LINK = "SEARCH_SUPPLIER_URL_LINK";
export const SEARCH_SUPPLIER_URL_LINK_SUCCESS =
  "SEARCH_SUPPLIER_URL_LINK_SUCCESS";
export const SEARCH_SUPPLIER_URL_LINK_FAILURE =
  "SEARCH_SUPPLIER_URL_LINK_FAILURE";

export const GET_SUPPLIER_URL_LINK_DETAILS = "GET_SUPPLIER_URL_LINK_DETAILS";
export const GET_SUPPLIER_URL_LINK_DETAILS_SUCCESS =
  "GET_SUPPLIER_URL_LINK_DETAILS_SUCCESS";
export const GET_SUPPLIER_URL_LINK_DETAILS_FAILURE =
  "GET_SUPPLIER_URL_LINK_DETAILS_FAILURE";

export const CREATE_SUPPLIER_URL_LINK = "CREATE_SUPPLIER_URL_LINK";
export const CREATE_SUPPLIER_URL_LINK_SUCCESS =
  "CREATE_SUPPLIER_URL_LINK_SUCCESS";
export const CREATE_SUPPLIER_URL_LINK_FAILURE =
  "CREATE_SUPPLIER_URL_LINK_FAILURE";

export const UPDATE_SUPPLIER_URL_LINK = "UPDATE_SUPPLIER_URL_LINK";
export const UPDATE_SUPPLIER_URL_LINK_SUCCESS =
  "UPDATE_SUPPLIER_URL_LINK_SUCCESS";
export const UPDATE_SUPPLIER_URL_LINK_FAILURE =
  "UPDATE_SUPPLIER_URL_LINK_FAILURE";

export const DELETE_SUPPLIER_URL_LINK = "DELETE_SUPPLIER_URL_LINK";
export const DELETE_SUPPLIER_URL_LINK_SUCCESS =
  "DELETE_SUPPLIER_URL_LINK_SUCCESS";
export const DELETE_SUPPLIER_URL_LINK_FAILURE =
  "DELETE_SUPPLIER_URL_LINK_FAILURE";

export const GET_SUPPLIER_URL_LINK_STATUS_LIST =
  "GET_SUPPLIER_URL_LINK_STATUS_LIST";
export const GET_SUPPLIER_URL_LINK_STATUS_LIST_SUCCESS =
  "GET_SUPPLIER_URL_LINK_STATUS_LIST_SUCCESS";
export const GET_SUPPLIER_URL_LINK_STATUS_LIST_FAILURE =
  "GET_SUPPLIER_URL_LINK_STATUS_LIST_FAILURE";

export const GET_SUPPLIER_URL_LINK_TYPE_LIST =
  "GET_SUPPLIER_URL_LINK_TYPE_LIST";
export const GET_SUPPLIER_URL_LINK_TYPE_LIST_SUCCESS =
  "GET_SUPPLIER_URL_LINK_TYPE_LIST_SUCCESS";
export const GET_SUPPLIER_URL_LINK_TYPE_LIST_FAILURE =
  "GET_SUPPLIER_URL_LINK_TYPE_LIST_FAILURE";
